import { combineReducers } from 'redux';
import userReducer from './userSlice';
import browseReducer from "./browseSlice";

export default combineReducers({
  userReducer,
  browseReducer
});
